/**
 * Centralised DOMPurify wrapper used everywhere we render user-/AI-supplied
 * HTML via `dangerouslySetInnerHTML`. Sanitises against XSS (script tags,
 * inline event handlers, javascript: URIs, etc.) while keeping the rich
 * inline markup our blog editor produces (links, emphasis, code, etc.).
 *
 * Usage:
 *   import { safeHtml } from "@/lib/sanitize";
 *   <p dangerouslySetInnerHTML={{ __html: safeHtml(content) }} />
 */
import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "a", "b", "br", "code", "em", "i", "kbd", "mark", "s", "small", "span",
  "strong", "sub", "sup", "u",
];

const ALLOWED_ATTR = ["href", "title", "target", "rel", "class", "id"];

export function safeHtml(input) {
  if (!input || typeof input !== "string") return "";
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus"],
  });
}

export default safeHtml;
